import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { GOOGLE_MAPS_API_KEY } from './config';

// Load Google Maps API with key from environment variables
// This happens during build time so the key will be embedded in the output JS
const loadGoogleMapsAPI = () => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

// Load the Google Maps API script
loadGoogleMapsAPI();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
